import { useAuth } from '../../context/AuthContext';
import { ChattingShell, useChattingData, usePeriod, PREV_LABEL } from './ChattingShell';
import { ChatterHeadline, ChatterDetailGrid } from './ChatterStatCards';
import { ChattersTable } from './ChattersTable';
import { money } from './TimeframeSelect';

export const ChattingOverview = ({ title = 'Dashboard', subtitle, refreshKey }) => {
  const { user } = useAuth();
  const period = usePeriod();
  const { timeframe } = period;
  const { data, error, loading } = useChattingData('overview', period, refreshKey);
  const t = data?.totals;

  return (
    <ChattingShell title={title} subtitle={subtitle || `Chatting overview · ${user?.name}`} period={period}
      error={error} fetchedAt={data?.fetched_at} stale={data?.stale}>
      {loading && !data ? <div className="text-zinc-400">Loading...</div> : (
        <>
          {t?.pending_attribution > 0 && (
            <div className="text-sm text-amber-400" data-testid="pending-attribution">
              {t.pending_attribution} tips/chargebacks still being matched to chatters, numbers will update shortly.
            </div>
          )}
          <ChatterHeadline s={t} prev={data?.previous_totals} prevLabel={PREV_LABEL[timeframe]} ratePercent={data?.rate_percent} earningsLabel="Chatter pay" />
          <ChatterDetailGrid s={t} />
          {t?.unattributed_tips > 0 && (
            <div className="text-xs text-zinc-500" data-testid="unattributed-tips">
              Tips not credited to any chatter: {money(t.unattributed_tips)}
            </div>
          )}
          {t?.unattributed_chargebacks > 0 && (
            <details className="text-xs text-zinc-500" data-testid="unattributed-chargebacks">
              <summary className="cursor-pointer">Chargebacks not linked to any chatter: {money(t.unattributed_chargebacks)} (click for details)</summary>
              <div className="mt-2 space-y-1 pl-4">
                {(t.unlinked_chargebacks || []).map((c, i) => (
                  <div key={i}>{new Date(c.date).toLocaleDateString()} · {money(c.amount)} · {c.reason}</div>
                ))}
              </div>
            </details>
          )}
          {t?.post_tips > 0 && (
            <div className="text-xs text-zinc-500" data-testid="post-tips">
              Tips on posts (excluded like Fanvue, not credited to chatters): {money(t.post_tips)}
            </div>
          )}
          <div>
            <h2 className="text-base md:text-lg font-semibold font-heading text-white mb-3">Chatters</h2>
            <ChattersTable chatters={data?.chatters} />
          </div>
        </>
      )}
    </ChattingShell>
  );
};
